import { logout } from 'src/redux/feature/userSlice'

export const Interceptor = (store) => (next) => (action) => {
  if (action.payload && action.payload.status === 401) {
    store.dispatch(logout())
  }

  return next(action)
}
